(function() {
    'use strict';
    function MwActivityModal($translate, ActivityService) {
        var _this = this;

        this.$translate = $translate;
        this.ActivityService = ActivityService;
        this.shouldValidateForm = false;
        if (this.createdString) {
            this.dialogTitle = this.$translate.instant('icm-web__contact-profile--activity-title-edit');
        } else {
            this.dialogTitle = this.$translate.instant('icm-web__contact-profile--activity-title-create');
        }
        this.activityTypeTitle = 'icm-web__contact-profile--activity-type-title';
        this.subjectLabelText = 'icm-web__contact-profile--activity-subject-label';
        this.noteLabelText = 'icm-web__contact-profile--activity-note-label';
        this.dateLabelText = 'icm-web__contact-profile--activity-date-label';
        this.okButtonText = this.$translate.instant('Save');
        this.cancelButtonText = this.$translate.instant('Cancel');

        this.errorMessages = {
            errorBanner: 'icm-web__contact-profile--activity-error',
            typeRequired: 'icm-web__contact_profile--activity-type-required-error',
            bodyRequired: 'icm-web__contact-profile--activity-note-body-error',
            dateRequired: 'icm-web__contact_profile--activity-date-required-error',
            maxLengthError: 'icm-web__contact_profile--activity-max-length-error'
        };

        this.dateConfig = {
            formInputName: 'date',
            locale: 'en',
            minView: 'month',
            maxView: 'month',
            label: 'Date',
            format: 'L',
            changeDate: function($event) {
                _this.date = $event.date;
            },
            timezone: 'UTC' // this does not matter since we are not using time, just date. but we need it set or we see errors loading the component
        };

        this.activityTypes = this.ActivityService.getActivityTypes();

        // --------------
        // Modal Actions
        // --------------
        this.cancelModal = function cancelModal() {
            this.cancelCallback();
        };

        this.okModal = function okModal() {
            if (!this.activityForm.$valid) {
                this.shouldValidateForm = true;
            } else {
                this.shouldValidateForm = false;
                this.okCallback({selectedType: this.selectedType, subject: this.subject, body: this.body, date: this.date});
            }
        };
    }

    angular
        .module('MW.ContactManager.MwActivityModal', ['MW.Influencers.ActivityService'])
        .component('mwActivityModal', {
            bindings: {
                cancelCallback: '&',
                okCallback: '&',
                selectedType: '<',
                subject: '<',
                body: '<',
                date: '<',
                createdString: '<',
                updatedString: '<'
            },
            controller: ['$translate', 'ActivityService', MwActivityModal],
            template: `
                <mw-mini-modal-dialog layout="column" dialog-title="{{$ctrl.dialogTitle}}" ok="{{$ctrl.okButtonText}}" cancel="{{$ctrl.cancelButtonText}}" on-ok="$ctrl.okModal()" on-cancel="$ctrl.cancelModal()">
                    <mw-modal-alert-message layout="column" ng-if="$ctrl.shouldValidateForm">
                        <div ng-if="$ctrl.shouldValidateForm" translate>{{$ctrl.errorMessages.errorBanner}}</div>
                    </mw-modal-alert-message>
                    <mw-modal-content>
                        <ng-form name="$ctrl.activityForm">
                            <div layout="column">
                                <md-input-container class="activity-type" md-is-error="$ctrl.shouldValidateForm && !$ctrl.selectedType">
                                    <label translate>{{$ctrl.activityTypeTitle}}</label>
                                    <md-select required="" ng-model="$ctrl.selectedType" md-no-ink>
                                        <md-option ng-repeat="activityType in $ctrl.activityTypes" value="{{activityType.value}}">{{activityType.display}}</md-option>
                                    </md-select>
                                    <!-- very strange issue when combining a md-select with the name attribute + a textarea in a modal. see GYDA-37827 -->
                                    <div class="md-input-messages-animation" ng-if="$ctrl.shouldValidateForm && !$ctrl.selectedType">
                                        <div class="md-input-message-animation" translate>{{$ctrl.errorMessages.typeRequired}}</div>
                                    </div>
                                </md-input-container>
                                <md-input-container class="activity-subject" md-is-error="$ctrl.activityForm.subject.$invalid">
                                    <label translate>{{$ctrl.subjectLabelText}}</label>
                                    <input name="subject" ng-model="$ctrl.subject" md-maxlength="240"/>
                                    <div ng-messages="$ctrl.activityForm.subject.$error">
                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.maxLengthError}}</div>
                                    </div>
                                </md-input-container>
                                <md-input-container class="activity-body" md-is-error="$ctrl.activityForm.body.$error['md-maxlength'] || ($ctrl.shouldValidateForm && $ctrl.activityForm.body.$invalid)">
                                    <label translate>{{$ctrl.noteLabelText}}</label>
                                    <textarea required="" name="body" ng-model="$ctrl.body" md-maxlength="10000" rows="3" md-select-on-focus=""></textarea>
                                    <div ng-messages="$ctrl.activityForm.body.$error">
                                        <div ng-message="required" translate>{{$ctrl.errorMessages.bodyRequired}}</div>
                                        <div ng-message="md-maxlength" translate>{{$ctrl.errorMessages.maxLengthError}}</div>
                                    </div>
                                </md-input-container>
                                <md-input-container class="activity-date" md-is-error="$ctrl.shouldValidateForm && $ctrl.activityForm.date.$invalid">
                                    <label translate>{{$ctrl.dateLabelText}}</label>
                                    <mw-date-picker-dropdown
                                        form-input-name="$ctrl.dateConfig.formInputName"
                                        is-required="true"
                                        date="$ctrl.date"
                                        locale="$ctrl.dateConfig.locale"
                                        min-view="$ctrl.dateConfig.minView"
                                        max-view="$ctrl.dateConfig.maxView"
                                        format="$ctrl.dateConfig.format"
                                        timezone="$ctrl.dateConfig.timezone"
                                        on-date-selection="$ctrl.dateConfig.changeDate($event)"
                                    > </mw-date-picker-dropdown>
                                    <div ng-messages="$ctrl.activityForm.date.$error">
                                        <div ng-message="required" translate>{{$ctrl.errorMessages.dateRequired}}</div>
                                    </div>
                                </md-input-container>
                            </div>
                        </ng-form>
                        <div class="activity-timestamps" ng-if="$ctrl.createdString" layout="column">
                            <span class="created-at">{{$ctrl.createdString}}</span>
                            <span class="updated-at" ng-if="$ctrl.updatedString">{{$ctrl.updatedString}}</span>
                        </div>
                    </mw-modal-content>
                </mw-mini-modal-dialog>
            `
        });
}());
